var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent", staticStyle: { height: "calc(100vh - 50px)" } },
    [
      _c("div", {
        staticStyle: { height: "30px", padding: "15px", "font-size": "16px" },
        attrs: { id: "jobInfoText" }
      }),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "margin-left": "25px", "margin-right": "25px" }
      }),
      _vm._v(" "),
      _c("layout-3", {
        staticStyle: { "max-height": "30vh" },
        attrs: { id: _vm.pageid, term: _vm.term, width: 3, height: 4 }
      }),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "margin-left": "25px", "margin-right": "25px" }
      }),
      _vm._v(" "),
      _vm.perms.includes("36")
        ? _c("layout-7", {
            staticStyle: { width: "100%", height: "calc(100vh - 480px)" },
            attrs: {
              id: _vm.pageid3,
              term: _vm.term,
              title: "Job Activities",
              binds: [5, 6],
              edit_types: [
                null,
                null,
                null,
                "Employee",
                "DateTime",
                "Value",
                null
              ],
              edit_perm: "37"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "nav-bar" }, [
        _c("div", [
          _vm.perms.includes("16")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.button("Edit")
                    }
                  }
                },
                [_vm._v("Edit Job Schedule")]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b49186c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b49186c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/View_Schedules.vue
// module id = 535
// module chunks = 0